import axios from '@/plugins/axios.js';

export function list(params) {
    return axios.get("mp/suggestion/list", { params: params });
}

export function remove(id) {
    return axios.delete(`mp/suggestion/${id}`);
}

export function deal(params) {
    return axios.post(`mp/suggestion/deal`,params);
}